var React = require('react');

function IcnX (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"#FFBABC","key":0}),React.createElement("path",{"d":"M20 10L10 20","stroke":"#0C0D0F","strokeWidth":"2.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M10 10L20 20","stroke":"#0C0D0F","strokeWidth":"2.5","strokeLinecap":"round","key":2})]);
}

IcnX.defaultProps = {"aria-label":"non private search engines don't","width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = IcnX;

IcnX.default = IcnX;
